"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Nav = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _List = require("./List.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Nav = exports.Nav = _styledComponents["default"].div.withConfig({
  displayName: "Nav",
  componentId: "sc-y9ijly-0"
})(["@media (max-width:", "){display:flex;flex-direction:row;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar;overflow-x:auto;white-space:nowrap;}", " &{@media (max-width:", "){display:none;}}@media (min-width:", "){display:block;}"], _encoreFoundation.screenXsMax, _List.List, _encoreFoundation.screenXsMax, _encoreFoundation.screenSmMin);